import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import CampaignList from '../components/campaigns/CampaignList';
import FuturePlans from '../components/campaigns/FuturePlans';
import './CampaignsPage.css';

const CampaignsPage = () => {
  return (
    <>
      <Header />
      <main>
        <CampaignList />
        <FuturePlans />
      </main>
      <Footer />
    </>
  );
};

export default CampaignsPage;
